'use client'

import { useTokenLoader } from '@/utils/auth/useTokenLoader'
import { useCompanyLoader } from '@/utils/useCompanyLoader'

export const InitApp = () => {
  useTokenLoader()
  useCompanyLoader()
  return null
}

export default InitApp
